const Creteemployee = () => {
  return (
    <div className="c-create-employee">
      <div className="c-create-employee__header">
        <span className="c-create-employee__title">Create Employee</span>
        <div className="c-create-employee__options">
          <button className="c-create-employee__save-changues c-create-employee__save-changues--discart">
            Discart
          </button>
          <button className="c-create-employee__save-changues">Save</button>
        </div>
      </div>
      <div className="c-create-employee__body">
        <div className="c-create-employee__item-box">
          <span className="c-create-employee__item-title">First Name</span>
          <input type="text" className="c-create-employee__input" />
        </div>
        <div className="c-create-employee__item-box">
          <span className="c-create-employee__item-title">Last Name</span>
          <input type="text" className="c-create-employee__input" />
        </div>
        <div className="c-create-employee__item-box">
          <span className="c-create-employee__item-title">Title</span>
          <input type="text" className="c-create-employee__input" />
        </div>
        <div className="c-create-employee__item-box">
          <span className="c-create-employee__item-title">City</span>
          <input type="text" className="c-create-employee__input" />
        </div>
        <div className="c-create-employee__item-box">
          <span className="c-create-employee__item-title">Zip Code</span>
          <input type="text" className="c-create-employee__input" />
        </div>
        <div className="c-create-employee__item-box">
          <span className="c-create-employee__item-title">VP</span>
          <input type="text" className="c-create-employee__input" />
        </div>
        <div className="c-create-employee__item-box">
          <span className="c-create-employee__item-title">Work Phone</span>
          <input type="text" className="c-create-employee__input" />
        </div>
        <div className="c-create-employee__item-box">
          <span className="c-create-employee__item-title">Custom Phone</span>
          <input type="text" className="c-create-employee__input" />
        </div>
        <div className="c-create-employee__item-box">
          <span className="c-create-employee__item-title">DM Name</span>
          <input type="text" className="c-create-employee__input" />
        </div>
        <div className="c-create-employee__item-box">
          <span className="c-create-employee__item-title">Email Address</span>
          <input type="text" className="c-create-employee__input" />
        </div>
        <div className="c-create-employee__item-box">
          <span className="c-create-employee__item-title">Mobile Phone</span>
          <input type="text" className="c-create-employee__input" />
        </div>
        <div className="c-create-employee__item-box">
          <span className="c-create-employee__item-title">Mobile Phone</span>
          <input type="text" className="c-create-employee__input" />
        </div>
        <div className="c-create-employee__item-box">
          <span className="c-create-employee__item-title">Address</span>
          <input type="text" className="c-create-employee__input" />
        </div>
        <div className="c-create-employee__item-box">
          <span className="c-create-employee__item-title">Departament</span>
          <input type="text" className="c-create-employee__input" />
        </div>
        <div className="c-create-employee__item-box">
          <span className="c-create-employee__item-title">Brand</span>
          <input type="text" className="c-create-employee__input" />
        </div>
        <div className="c-create-employee__item-box">
          <span className="c-create-employee__item-title">Location</span>
          <input type="text" className="c-create-employee__input" />
        </div>
        <div className="c-create-employee__item-box">
          <span className="c-create-employee__item-title">Location</span>
          <input type="text" className="c-create-employee__input" />
        </div>
        <div className="c-create-employee__item-box">
          <span className="c-create-employee__item-title">Job</span>
          <input type="text" className="c-create-employee__input" />
        </div>
        <div className="c-create-employee__item-box">
          <span className="c-create-employee__item-title">Job</span>
          <input type="text" className="c-create-employee__input" />
        </div>
      </div>
    </div>
  );
};

export default Creteemployee;
